import { v4 } from 'uuid';
const uuid = v4;
export { uuid };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXVpZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInV1aWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEVBQUUsRUFBRSxNQUFNLE1BQU0sQ0FBQztBQUUxQixNQUFNLElBQUksR0FBRyxFQUFVLENBQUM7QUFXeEIsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDIn0=